var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, Grid } from 'semantic-ui-react';
import { showModal } from 'app/actions/modalActions';
import IDColumn from './IDColumn';
import NameColumn from './NameColumn';
import StatusColumn from './StatusColumn';
import ActionColumn from './ActionColumn';
import { hasExpired } from '../helper';
import DropDown from '../../../components/Icons/Dropdown';
import SandboxItemExpand from './ExpandPanelItems/SandboxItemExpand';
var SandboxListItem = function (props) {
    var sandbox = props.sandbox, extendSandboxHashKey = props.extendSandboxHashKey, terminateSandboxHashKey = props.terminateSandboxHashKey, index = props.index, accessToken = props.accessToken, isActive = props.isActive, onItemClick = props.onItemClick, handleShowModal = props.handleShowModal, handleOnExtend = props.handleOnExtend;
    var allowExpand = function (s) {
        return !hasExpired(s.expires) &&
            !(s.status || s.status === 'PENDING' || s.status === 'DRAFT' || s.sbType === 'SandboxDraft');
    };
    var handleExtend = function () {
        handleOnExtend({
            type: 'extend',
            data: __assign(__assign({}, sandbox), { clickedFrom: 'list' }),
        });
    };
    var onBloomLaunch = function (data) {
        handleShowModal({
            type: 'bloomLaunch',
            data: {
                sandbox: data,
            },
        });
    };
    var onNeulerLaunch = function (data) {
        handleShowModal({
            type: 'neulerLaunch',
            data: {
                sandbox: data,
            },
        });
    };
    var onNeodashLaunch = function (data) {
        handleShowModal({
            type: 'neodashLaunch',
            data: {
                sandbox: data,
            },
        });
    };
    var onToolsLaunch = function (data) {
        handleShowModal({
            type: 'toolsLaunch',
            data: {
                sandbox: data,
            },
        });
    };
    var onWorkspaceLaunch = function (data) {
        handleShowModal({
            type: 'workspaceLaunch',
            data: {
                sandbox: data,
            },
        });
    };
    var handleClick = function (e) {
        // Ignore if the click came through button (button click is to open Browser and not expand/unexpand)
        if (e.target.tagName && e.target.tagName.toLowerCase() === 'button')
            return;
        window.neo4jSandbox.tracking.event(isActive ? 'SANDBOX_ITEM_UNEXPAND' : 'SANDBOX_ITEM_EXPAND', {
            usecase: sandbox.usecase,
        });
        onItemClick(index);
    };
    return (React.createElement(Card, { fluid: true, id: "project-item-".concat(index), className: "no-border-radius my0 no-shadow border-bottom" },
        React.createElement(Accordion.Title, { as: "div", fluid: "true", active: isActive },
            React.createElement(Card.Content, { variant: "link", style: {
                    padding: '1rem 1.25rem',
                    pointerEvents: allowExpand(sandbox) ? 'auto' : 'none',
                }, onClick: handleClick },
                React.createElement(Grid, null,
                    React.createElement(Grid.Column, { width: 5 },
                        React.createElement("div", { style: {
                                width: 48,
                                float: 'left',
                                display: 'inline-block',
                                textAlign: 'center',
                            } },
                            React.createElement(IDColumn, { data: sandbox })),
                        React.createElement("div", { className: "pl3" },
                            React.createElement(NameColumn, { data: sandbox }))),
                    React.createElement(Grid.Column, { width: 5 },
                        React.createElement(StatusColumn, { data: sandbox, onExtend: handleExtend })),
                    React.createElement(Grid.Column, { width: 6, className: "pl0" },
                        React.createElement(Grid, { verticalAlign: "middle" },
                            React.createElement(Grid.Column, { textAlign: "right", width: 14 },
                                React.createElement(ActionColumn, { data: sandbox, isTerminating: sandbox.sandboxHashKey === terminateSandboxHashKey, isExtending: sandbox.sandboxHashKey === extendSandboxHashKey, onBloomLaunch: onBloomLaunch, onNeulerLaunch: onNeulerLaunch, onNeodashLaunch: onNeodashLaunch, onToolsLaunch: onToolsLaunch, onWorkspaceLaunch: onWorkspaceLaunch, accessToken: accessToken })),
                            React.createElement(Grid.Column, { floated: "right", width: 2, onClick: handleClick, className: "item-dropdown-wrapper" }, allowExpand(sandbox) && (React.createElement("span", { id: "project-expand-".concat(index) },
                                React.createElement(DropDown, null))))))))),
        allowExpand(sandbox) && (React.createElement(Accordion.Content, { style: { border: 0, background: '#f9fbfd' }, active: props.isActive, className: "expand" },
            React.createElement(Card.Content, { style: { border: 0 } },
                React.createElement(SandboxItemExpand, { data: sandbox }))))));
};
var mapDispatchToProps = function (dispatch) { return ({
    handleOnExtend: function (data) { return dispatch(showModal(data)); },
    handleShowModal: function (data) { return dispatch(showModal(data)); },
}); };
var mapStateToProps = function (state) { return ({
    terminateSandboxHashKey: state.sandbox.terminateSandboxHashKey,
    extendSandboxHashKey: state.sandbox.extendSandboxHashKey,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxListItem);
